import Vue from 'vue';

const actions = {
  validarConvite(_, { token, senhaTemporaria }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const response = await api.send(
        '/convite/validar',
        'POST',
        { token, senhaTemporaria },
        undefined,
        false,
      );

      if (response.status === 200) {
        resolve({
          status: 200,
          dados: response.data.dados,
          mensagem: response.data.mensagem,
        });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data?.mensagem || 'Não foi possível validar o convite.',
        });
      }
    });
  },

  definirSenhaConvite(_, { token, senhaTemporaria, novaSenha }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const response = await api.send(
        '/convite/definir-senha',
        'POST',
        { token, senhaTemporaria, novaSenha },
        undefined,
        false,
      );

      if (response.status === 200) {
        resolve({ status: 200, mensagem: response.data.mensagem });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data?.mensagem || 'Não foi possível definir a senha.',
        });
      }
    });
  },

  concluirConvite(_, { token }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const response = await api.send(
        '/convite/concluir',
        'POST',
        { token },
        undefined,
        false,
      );

      if (response.status === 200) {
        resolve({ status: 200, mensagem: response.data.mensagem });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data?.mensagem || 'Não foi possível concluir o onboarding.',
        });
      }
    });
  },
};

export default {
  namespaced: true,
  actions,
};
